<template>
  <div class="accent-note">
    <div class="accent-note__ico">
      <BaseSvg name="ico-star"/>
    </div>
    <h4 v-if="title"
        class="accent-note__title">
      {{ title }}
    </h4>
    <div v-if="text"
         v-html="text"
         class="accent-note__text  text">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AccentNote',
    props: [
      'title',
      'text'
    ]
  }
</script>

<style lang="less">

</style>
